/**
 * Created by ianandersen on 4/5/17.
 */

import React from 'react';
import Description from './FileProperties/Description';
import Download from './FileProperties/Download';
import RelatedFiles from './FileProperties/RelatedFiles';
import Series from './FileProperties/Series';
import Subtitle from './FileProperties/Subtitle';
import Tags from './FileProperties/Tags';
import Title from './FileProperties/Title';
import AudioPlayer from 'Components/Audio/AudioPlayer';
import Author from './FileProperties/Author';
import ShareButtons from 'Views/ShareButtons';
import DisplayDate from './FileProperties/DisplayDate';
import VideoFileGlobalPlayer from '../../Components/Video/VideoFileGlobalPlayer';

class AudioView extends React.Component{
  constructor(props){
    super(props);
    this.file = props.file;
  }

  render(){
    let file = this.file;
    return (
      <div className="container clearfix" style={{textAlign: 'center'}}>
        <div className="col-md-12">
          <a href="#" onClick={(e) => {e.preventDefault(); window.history.back();}} className="audio-file-back-button file-back-button">
            <h3 style={{cursor: 'pointer', fontSize: 20, textAlign: 'left'}}>
              <i className="fa fa-arrow-left"></i> Back
            </h3>
          </a>
          <div id='audioFile' className="audio-container aplayer" style={{marginTop: '100px'}}>
            {file.get("visibility") === 'private' && !this.props.userOwned ? null : <AudioPlayer audioID={file.get('id')} autoPlay={false} elementID="audioFile"/>}
          </div>
          <Title text={file.get('title')}/>
          <Subtitle text={file.get('subtitle')}/>
          <Author text={file.get('author')}/>
          <DisplayDate text={file.get('display_date')} />
          {file.get('related_files').length === 1 && file.get('related_files').first().fileType === 'video' ? <div>
            <div style={{width: '100%', maxWidth: 800, aspectRatio: '16 / 9', marginLeft: 'auto', marginRight: 'auto'}}>
              <VideoFileGlobalPlayer file={file.get('related_files').first()} width={'100%'} height={'100%'} />
            </div>
          </div>: null}
          <Description text={file.get('description')}/>
          {file.isDownloadable() ? <div style={{textAlign: 'center'}}>
            <Download file={file} name={file.get('title') + '.' + file.get('extension')} url={file.downloadLink} />
          </div> : null}
          {this.props.social.url ? <ShareButtons {...this.props.social}/> :
            <ShareButtons {...this.props.social} url={window.location.href}/>}
          <Series series={file.get('media_series')}/>
          {file.get('related_files').length === 1 && file.get('related_files').first().fileType === 'video' ? null : <RelatedFiles files={file.get('related_files')}/>}
          <Tags file={file}/>
        </div>
      </div>
    );
  }
}

export default AudioView;
